
















import Vue from "vue";
import Component from "vue-class-component";

import ChartLine from "@/shared/components/chart-line.vue";
import { Prop, Watch } from "vue-property-decorator";
import {
  CadastroAcumulado,
  DashboardService,
} from "@/services/dashboard.service";
import { ticks, title } from "@/shared/utils/chart";

@Component({
  components: { ChartLine },
})
export default class GraficoCadastroAcumulado extends Vue {
  //Atributos
  loading = false;
  dados: CadastroAcumulado[] | null = null;
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      callbacks: {
        title: title(),
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            callback: ticks(),
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            precision: 0,
            beginAtZero: true,
          },
        },
      ],
    },
  };
  //Fim atributos

  //Computed
  get labels() {
    return this.dados?.map((x) => x.data);
  }
  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        label: "Quantidade",
        backgroundColor: "#3e95cd",
        data: this.dados?.map((x) => x.totalEsteMes),
      },
      {
        label: "Mês Passado",
        backgroundColor: "#cecece",
        data: this.dados?.map((x) => x.totalMesPassado),
      },
    ];
  }
  //Fim Computed

  //Props
  @Prop() readonly value!: string;
  //Fim Props

  mounted() {
    this.onValueChange(this.value);
  }

  @Watch("value")
  async onValueChange(val: string) {
    this.loading = true;
    if (val) {
      this.dados = await DashboardService.CadastroAcumulado(val).finally(
        () => (this.loading = false)
      );
    }
  }
}
